export const adminDashboardFr = {
  // Navigation
  greeting: 'Bonjour',
  adminDashboard: 'Tableau de Bord Administrateur',
  home: 'Accueil',
  dashboard: 'Tableau de Bord',
  students: 'Étudiants',
  teachers: 'Enseignants',
  parents: 'Parents',
  grades: 'Notes',
  communication: 'Communication',
  communicationTitle: 'Messages et communication',
  messages: 'Messages',
  emails: 'E-mails',
  inscriptionRequests: "Demandes d'inscription",
  contactMessages: 'Communication externe',
  allStatuses: 'Tous les statuts',
  allTypes: 'Tous les types',
  allSchoolYears: 'Toutes les années',
  writeReply: 'Votre réponse...',
  archive: 'Archiver',
  reply: 'Répondre',
  send: 'Envoyer',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  reviewed: 'En cours',
  registered: 'Inscrit',
  pending: 'En attente',
  parent: 'Parent',
  teacher: 'Enseignant',
  statusNew: 'Nouveau',
  statusRead: 'Lu',
  statusReplied: 'Répondu',
  statusArchived: 'Archivé',
  registerParent: 'Inscrire le parent',
  registerChildren: 'Enregistrer les enfants',
  viewParent: 'Voir le profil du parent',
  requests: 'demandes',
  details: 'Détails',
  linkedAccount: 'Compte lié',
  children: 'Enfants',
  child: 'enfant',
  reviewerNotes: 'Notes du réviseur',
  by: 'par',
  notRegistered: 'Non inscrit',
  reEnroll: 'Réinscription',
  admins: 'Administrateurs',
  statistics: 'Statistiques',
  financialManagement: 'Gestion financière',
  expenses: 'Revenus et Dépenses',
  income: 'Revenus',
  expense: 'Dépense',
  incomeTotal: 'Total des Revenus',
  expenseTotal: 'Total des Dépenses',
  difference: 'Différence (Revenus - Dépenses)',
  addFinancialRecord: 'Ajouter revenu ou dépense',
  studentFees: 'Cotisation étudiants',
  teacherSalaries: 'Salaires des enseignants',
  
  // Monthly contributions
  academicYear: 'Année scolaire',
  category: 'Catégorie',
  type: 'Type',
  totalAmount: 'Montant total',
  annualEnrollment: 'Inscription annuelle',
  status: 'Statut',
  notes: 'Notes',
  september: 'Septembre',
  october: 'Octobre',
  november: 'Novembre',
  december: 'Décembre',
  january: 'Janvier',
  february: 'Février',
  march: 'Mars',
  april: 'Avril',
  may: 'Mai',
  june: 'Juin',
  july: 'Juillet',
  august: 'Août',
  paid: 'Payé',
  unpaid: 'Non payé',
  partial: 'Partiel',
  allStudents: 'Tous les étudiants',
  allParents: 'Tous les parents',
  allTeachers: 'Tous les enseignants',
  total: 'Total',
  actions: 'Actions',
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer ?',
  deleteSuccess: 'Supprimé avec succès',
  deleteError: 'Erreur lors de la suppression',
  
  // Common actions
  add: 'Ajouter',
  edit: 'Modifier',
  delete: 'Supprimer',
  update: 'Mettre à jour',
  save: 'Enregistrer',
  cancel: 'Annuler',
  search: 'Rechercher',
  filter: 'Filtrer',
  refresh: 'Actualiser',
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  confirm: 'Confirmer',
  close: 'Fermer',
  
  // Status
  active: 'Actif',
  inactive: 'Inactif',
  
  // Student management
  addStudent: 'Ajouter un Étudiant',
  editStudent: 'Modifier un Étudiant',
  deleteStudent: 'Supprimer un Étudiant',
  studentName: 'Nom de l\'Étudiant',
  studentPhone: 'Téléphone',
  studentIdNumber: 'Numéro de Carte',
  studentAddress: 'Adresse',
  studentLevel: 'Niveau',
  studentHalqa: 'Cercle',
  studentNotes: 'Notes',
  studentParent: 'Parent',
  studentTeacher: 'Enseignant',
  selectParent: 'Sélectionner un Parent',
  selectTeacher: 'Sélectionner un Enseignant',
  studentAddedSuccess: 'Étudiant ajouté avec succès',
  studentUpdatedSuccess: 'Étudiant modifié avec succès',
  studentDeletedSuccess: 'Étudiant supprimé avec succès',
  studentAddError: 'Erreur lors de l\'ajout de l\'étudiant',
  studentUpdateError: 'Erreur lors de la modification de l\'étudiant',
  studentDeleteError: 'Erreur lors de la suppression de l\'étudiant',
  confirmDeleteStudent: 'Êtes-vous sûr de vouloir supprimer cet étudiant ?',
  
  // Teacher nav sub-sections
  studentsParents: 'Élèves & Parents',
  administration: 'Administration',
  manageTeachers: 'Gestion des enseignants',
  quranTracking: 'Suivi mémorisation',
  studentProgress: 'Progrès des élèves',
  adminsList: 'Direction',

  // Teacher management
  addTeacher: 'Ajouter un Enseignant',
  editTeacher: 'Modifier un Enseignant',
  deleteTeacher: 'Supprimer un Enseignant',
  teacherName: 'Nom de l\'Enseignant',
  teacherUsername: 'Nom d\'utilisateur',
  teacherPassword: 'Mot de passe',
  teacherEmail: 'Adresse e-mail',
  teacherPhone: 'Téléphone',
  teacherSpecialization: 'Spécialisation',
  teacherExperience: 'Années d\'Expérience',
  teacherHireDate: 'Date d\'Embauche',
  teacherSalary: 'Salaire',
  teacherAssignedHalqas: 'Cercles Assignés',
  teacherNotes: 'Notes',
  teacherAddedSuccess: 'Enseignant ajouté avec succès',
  teacherUpdatedSuccess: 'Enseignant mis à jour avec succès',
  teacherDeletedSuccess: 'Enseignant supprimé avec succès',
  teacherAddError: 'Erreur lors de l\'ajout de l\'enseignant',
  teacherUpdateError: 'Erreur lors de la mise à jour de l\'enseignant',
  teacherDeleteError: 'Erreur lors de la suppression de l\'enseignant',
  confirmDeleteTeacher: 'Êtes-vous sûr de vouloir supprimer cet enseignant ?',
  
  // Parent management
  addParent: 'Ajouter un Parent',
  editParent: 'Modifier un Parent',
  deleteParent: 'Supprimer un Parent',
  parentName: 'Nom du Parent',
  parentUsername: 'Nom d\'utilisateur',
  parentEmail: 'Adresse e-mail',
  parentPhone: 'Téléphone',
  parentNotes: 'Notes',
  parentAddedSuccess: 'Parent ajouté avec succès',
  parentUpdatedSuccess: 'Parent mis à jour avec succès',
  parentDeletedSuccess: 'Parent supprimé avec succès',
  parentAddError: 'Erreur lors de l\'ajout du parent',
  parentUpdateError: 'Erreur lors de la mise à jour du parent',
  parentDeleteError: 'Erreur lors de la suppression du parent',
  confirmDeleteParent: 'Êtes-vous sûr de vouloir supprimer ce parent ?',
  
  // Admin management
  addAdmin: 'Ajouter un Administrateur',
  editAdmin: 'Modifier un Administrateur',
  deleteAdmin: 'Supprimer un Administrateur',
  adminName: 'Nom de l\'Administrateur',
  adminUsername: 'Nom d\'utilisateur',
  adminPassword: 'Mot de passe',
  adminPasswordConfirm: 'Confirmer le mot de passe',
  adminEmail: 'Adresse e-mail',
  adminPhone: 'Téléphone',
  adminPermissions: 'Permissions',
  adminNotes: 'Notes',
  adminAddedSuccess: 'Administrateur ajouté avec succès',
  adminUpdatedSuccess: 'Administrateur mis à jour avec succès',
  adminDeletedSuccess: 'Administrateur supprimé avec succès',
  adminAddError: 'Erreur lors de l\'ajout de l\'administrateur',
  adminUpdateError: 'Erreur lors de la mise à jour de l\'administrateur',
  adminDeleteError: 'Erreur lors de la suppression de l\'administrateur',
  confirmDeleteAdmin: 'Êtes-vous sûr de vouloir supprimer cet administrateur ?',
  
  // Grade management
  addGrade: 'Ajouter une Note',
  editGrade: 'Modifier une Note',
  deleteGrade: 'Supprimer une Note',
  gradeStudent: 'Étudiant',
  gradeSubject: 'Matière',
  gradeValue: 'Note',
  gradeDate: 'Date',
  gradeComment: 'Commentaire',
  student: 'Étudiant',
  studentLabel: 'Étudiant(e)',
  subject: 'Matière',
  grade: 'Note',
  date: 'Date',
  comment: 'Commentaire',
  selectStudent: 'Sélectionner un Étudiant',
  selectSubject: 'Sélectionner une Matière',
  gradeAddedSuccess: 'Note ajoutée avec succès',
  gradeDeletedSuccess: 'Note supprimée avec succès',
  gradeAddError: 'Erreur lors de l\'ajout de la note',
  gradeDeleteError: 'Erreur lors de la suppression de la note',
  confirmDeleteGrade: 'Êtes-vous sûr de vouloir supprimer cette note ?',
  
  // Communication
  sendMessage: 'Envoyer un Message',
  sentMessages: 'Messages Envoyés',
  receivedMessages: 'Messages Reçus',
  emailsSending: 'Emails Envoyés',
  emailsReceiving: 'Emails Reçus',
  messageRecipient: 'Destinataire',
  messageSubject: 'Sujet du Message',
  messageContent: 'Contenu du Message',
  from: 'De',
  messagePriority: 'Priorité',
  messageType: 'Type de Message',
  messageSentSuccess: 'Message envoyé avec succès',
  messageSendError: 'Erreur lors de l\'envoi du message',
  
  // Statistics
  totalStudents: 'Total Étudiants',
  totalTeachers: 'Total Enseignants',
  totalParents: 'Total Parents',
  averageGrade: 'Moyenne des Notes',
  unreadMessages: 'Messages Non Lus',
  noReceivedMessages: 'Aucun message reçu',
  unknown: 'Inconnu',
  
  // Form validation
  required: 'Requis',
  invalidFormat: 'Format invalide',
  password: 'Mot de passe',
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  unknownError: 'Erreur inconnue',
  
  // Placeholders
  notSpecified: 'Non spécifié',
  noData: 'Aucune donnée',
  selectOption: 'Sélectionner une option',
  
  // Levels
  levelKindergarten: 'Maternelle',
  level1: 'Premier',
  level2: 'Deuxième',
  level3: 'Troisième',
  level4: 'Quatrième',
  level5: 'Cinquième',
  level6: 'Sixième',
  levelMiddle: 'Collège',
  levelSecondary: 'Lycée',
  
  // Halqas
  halqaMemorizationBook: 'Cercle de Mémorisation avec Livre',
  halqaMemorizationListening: 'Cercle de Mémorisation par Écoute',
  
  // Back to home
  backToHome: 'Retour à la Page d\'Accueil',
  logout: 'Déconnexion',
  
  // Placeholders
  enterStudentName: 'Entrez le nom de l\'étudiant',
  enterPhone: 'Entrez le numéro de téléphone',
  enterIdNumber: 'Entrez le numéro de carte d\'identité',
  enterAddress: 'Entrez l\'adresse',
  enterNotes: 'Entrez des notes supplémentaires',
  enterGrade: 'Entrez la note',
  enterMessageSubject: 'Entrez le sujet du message',
  enterMessageContent: 'Entrez le contenu du message',
  enterTeacherFullName: 'Entrez le nom complet de l\'enseignant',
  enterAdminFullName: 'Entrez le nom complet de l\'administrateur',
  enterEmail: 'Entrez l\'adresse e-mail',
  confirmPassword: 'Confirmez le mot de passe',
  newPasswordOptional: 'Nouveau mot de passe (optionnel)',
  teacherNotesOptional: 'Notes sur l\'enseignant (optionnel)',
  phoneFormat: '01xxxxxxxxx',

  // Quran Tracking
  quranTrackingTitle: 'Suivi mémorisation du Coran',
  addNewRecord: 'Ajouter un enregistrement',
  noStudents: 'Aucun élève',
  noStudentsFilter: 'Aucun élève ne correspond au filtre',
  previousSessions: 'Sessions précédentes',
  noRecords: 'Aucun enregistrement disponible',
  editQuranRecord: 'Modifier l\'enregistrement',
  addQuranRecord: 'Ajouter un enregistrement Coran',
  hide: 'Masquer',
  show: 'Afficher',
  parameters: 'Paramètres',
  parametersSection: 'Gestion des Paramètres',
  parameterName: 'Nom du paramètre',
  parameterValue: 'Valeur',
  parameterDescription: 'Description',
  addParameter: 'Ajouter un paramètre',
  editParameter: 'Modifier le paramètre',
  deleteParameter: 'Supprimer le paramètre',
  parameterNamePlaceholder: 'Exemple: targetRepeatNewHifzCount',
  parameterValuePlaceholder: 'Entrez la valeur',
  parameterDescriptionPlaceholder: 'Entrez la description (optionnel)',
  parameterNameNote: 'Le nom doit être en format technique anglais (ex: targetRepeatNewHifzCount)',
  parameterCreated: 'Paramètre créé avec succès',
  parameterUpdated: 'Paramètre mis à jour avec succès',
  parameterDeleted: 'Paramètre supprimé avec succès',
  confirmDeleteParameter: 'Êtes-vous sûr de vouloir supprimer ce paramètre ?',
  parameterNameRequired: 'Le nom du paramètre est requis',
  parameterValueRequired: 'La valeur du paramètre est requise',
  parameterAlreadyExists: 'Un paramètre avec ce nom existe déjà',
  noParameters: 'Aucun paramètre',
  schoolYearSystemTitle: 'Année scolaire (système)',
  schoolYearSelectLabel: 'Année scolaire',
  schoolYearCalendarHint: 'Par défaut : 1er septembre → 31 août (modifiable à la création)',
  schoolYearStartDate: 'Début',
  schoolYearEndDate: 'Fin',
  schoolYearClose: 'Clôturer l\'année',
  schoolYearCloseTitle: 'Clôturer l\'année scolaire',
  schoolYearCloseHelp: 'L\'année courante passera en lecture seule. Choisissez l\'année à activer.',
  schoolYearActivate: 'Activer l\'année',
  schoolYearConfirmClose: 'Clôturer et activer',
  schoolYearClosing: 'Clôture…',
  schoolYearCloseNeedNew:
    'Créez d\'abord la nouvelle année (« Nouvelle année »), puis clôturez l\'année courante.',
  schoolYearNew: 'Créer une année',
  schoolYearCreate: 'Créer',
  schoolYearCancel: 'Annuler',
  schoolYearCreating: 'Création…',
  schoolYearCloseError: 'Erreur lors de la clôture',
  current: 'courante',
  closed: 'clôturée',
  parametersGeneralSection: 'Autres paramètres de l\'application',
  createdDate: 'Date de création',
  updatedDate: 'Dernière mise à jour',

  // Dashboard stats
  refreshing: 'Actualisation…',
  refreshDashboard: 'Recharger les données du tableau de bord',
  lastRefresh: 'Mise à jour à',
  statTotalStudents: 'Total étudiants',
  statPresentToday: 'Présents aujourd\'hui',
  noSessionsToday: 'Aucune séance',
  kpiPerimeterMismatch: 'Périmètre en cours de synchronisation',
  statAbsentToday: 'Absents aujourd\'hui',
  statPendingRequests: 'Demandes en attente',
  statNewMessages: 'Nouveaux messages',

  // Dashboard tabs
  tabActivities: 'Activités récentes',
  tabLastSession: 'Présence — Dernière session',
  tabAttendanceByDate: 'Présence par date',

  // Activity labels
  actMessageFrom: 'Message de',
  actUnknownSender: 'Expéditeur inconnu',
  actNoContent: 'Contenu non disponible',
  actUnknownDate: 'Date inconnue',
  actNoMessages: 'Aucun message récent',
  actNoMessagesDesc: 'Aucun message trouvé dans le système',
  actPendingRegistration: 'demande(s) d\'inscription en attente',
  actClickDetails: 'Cliquer pour les détails',
  actNewContactMessage: 'nouveau(x) message(s) de contact',
  actClickReply: 'Cliquer pour répondre',
  actTotalStudents: 'Total étudiants inscrits',
  actStudentInSystem: 'étudiant(s) inscrit(s) dans le système',
  actActiveTeachers: 'Enseignants actifs',
  actTeacherInSystem: 'enseignant(s) actif(s) dans le système',
  actNow: 'Maintenant',
  actPresent: 'Présent',
  actAbsent: 'Absent',
  actSaving: 'Enregistrement...',

  // Generic UI
  all: 'Tous',
  male: 'Masculin',
  female: 'Féminin',
  gender: 'Genre',
  phone: 'Téléphone',
  permissions: 'Permissions',
  to: 'À',
  username: 'Nom d\'utilisateur',
  adminTitle: 'Administrateur',
  administrationBoard: 'Tableau de bord',
  applicantInfo: 'Informations du demandeur',
  teacherInfoLabel: 'Informations de l\'enseignant',
  memorizedHizb: 'Hizb mémorisé',
  presentFilter: 'Présents',
  absentFilter: 'Absents',
  allTeachersOption: 'Tous les enseignants',

  // Empty states
  noSentMessages: 'Aucun message envoyé',
  noAdminsRegistered: 'Aucun administrateur enregistré',
  noFinancialRecords: 'Aucun enregistrement financier',
  noContributions: 'Aucune contribution enregistrée',
  noSalaries: 'Aucun salaire enregistré',
  noAccessPermission: 'Vous n\'avez pas accès à cette section',
  totalAbsences: 'Total absences',
  noTeachersRegistered: 'Aucun enseignant enregistré',
  inactiveFilterHint: 'Coché : les enseignants inactifs sont affichés eux aussi',
  noActiveTeachers: 'Aucun enseignant actif. Cochez « Inactif » pour les afficher',
  addTestScore: 'Ajouter une note',
  gradeOutOf20: 'Note (/20)',
  noTestScores: 'Aucune note d\'examen enregistrée',
  addTestScoreHint: 'Cliquez sur "Ajouter une note" pour ajouter une nouvelle note',
  noSubjectsAvailable: 'Aucune matière disponible',
  // Students / Parents UI
  infoSectionTitle: '📋 Informations',
  filters: '🔍 Filtres',
  selectColumns: 'Sélectionner les colonnes',
  selectAll: 'Tout sélectionner',
  resetFilters: 'Réinitialiser les filtres',
  viewTable: 'Vue tableau',
  viewCards: 'Vue cartes',
  noFilterResults: 'Aucun résultat correspondant aux filtres',
  tryChangingFilters: 'Essayez de modifier les critères de filtrage',
  noStudentsRegistered: 'Aucun élève enregistré dans le système',
  addStudentHint: 'Cliquez sur "Ajouter un élève" pour en ajouter un',
  noParentsRegistered: 'Aucun parent enregistré pour l\'instant',
  noFilterResultsParents: 'Aucun résultat pour cette recherche',
  addParentHint: 'Cliquez sur "Ajouter un parent" pour en ajouter un',
  addNewStudent: 'Ajouter un nouvel élève',
  editStudentTitle: 'Modifier les données de l\'élève',
  addNewParent: 'Ajouter un nouveau parent',
  editParentTitle: 'Modifier les données du parent',
  noChildrenRegistered: 'Aucun enfant enregistré',
  childrenSection: '🎓 Enfants',
  personalInfoSection: '📋 Informations personnelles',
  saveChanges: 'Enregistrer les modifications',
  selectLevel: 'Choisir le niveau',
  selectHalqa: 'Choisir la halqa',
  newPassword: 'Nouveau mot de passe',
  optional: '(optionnel)',
  sendCredentials: 'Envoyer les identifiants via :',
  saveStudent: 'Enregistrer l\'élève',
  saveParent: 'Ajouter le parent',
  errorAddingStudent: 'Erreur lors de l\'ajout de l\'élève',
  errorEditingStudent: 'Erreur lors de la modification de l\'élève',
  errorAddingParent: 'Erreur lors de l\'ajout du parent',
  errorEditingParent: 'Erreur lors de la modification du parent',
  noParentsAvailable: 'Aucun parent enregistré dans le système',
  suspended: 'Suspendu',
  withdrawn: 'Retiré',
  address: 'Adresse',
  email: 'Email',
  averageTestScores: 'Moyenne des notes',
  memorizationStatistics: 'Statistiques de mémorisation',
  memorizationLevelAdvanced: 'Avancés',
  memorizationLevelIntermediate: 'Intermédiaires',
  memorizationLevelBeginner: 'Débutants',
  noStudentsMatchFilter: 'Aucun élève ne correspond aux filtres',

  // Quran tracking - colonnes tableau séances précédentes
  quranTableDate: 'Date',
  quranTableNewHifz: 'Nouveau Hifz',
  quranTableOldMurajah: 'Murājaʿah ancien',
  quranTableNewMurajah: 'Murājaʿah nouveau',
  quranTableEvalNewHifz: 'Éval. Hifz',
  quranTableEvalOldMurajah: 'Éval. Murājaʿah ancien',
  quranTableEvalNewMurajah: 'Éval. Murājaʿah nouveau',
  quranTableNote: 'Note',
  quranTableHizb: 'Nb. Hizb',
  quranHizbLabel: 'hizb mémorisé',
  quranProgressLabel: 'Progression',
  quranProgressPercent: '% du Coran',
};

